import React from 'react';
import LeadManagement from '../components/LeadManagement';
import { useAuth } from '../contexts/AuthContext';

const LeadsPage = () => {
  const { user } = useAuth();
  
  return <LeadManagement currentUser={user} />;
};

export default LeadsPage; 